<template>
  <div class="todaycourse-page-main">
    <div class="search search-div">
      <van-search
        v-model="keywords"
        shape="round"
        @input="search"
        placeholder="请输入搜索关键词"
      />
    </div>
    <div class="date-div">
      <div @click="reduce" class="icon-button">
        <span class="iconfont icon-shangyibu"></span>
      </div>
      <div class="day-title">{{ dayName }}</div>
      <div @click="add" class="icon-button">
        <span class="iconfont icon-xiayibu"></span>
      </div>
    </div>
    <div class="todaycourse-scroll-box">
      <teas-today-course-list
        :url="urlOfflineShift"
        :is-design="isDesign"
        @itemClick="itemClick"
      >
      </teas-today-course-list>
    </div>
  </div>
</template>

<script>
import teasTodayCourseList from "./teasTodayCourseList.vue";
export default dsf.component({
  name: "DsfMobileTeasTodayCourseMain",
  ctrlCaption: "今日课程",
  mixins: [$mixins.control],
  design: {
    isMask: false,
  },
  components: {
    teasTodayCourseList,
  },
  props: {
    url: {
      type: String,
      default: "",
    },
    classType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      urlOfflineShift: "",
      dayWeek: [],
      weekNum: 0,
      currentDate: "",
      classId: "",
      keywords: "",
    };
  },
  computed: {
    dayName() {
      let weekName = "";
      if (!this.currentDate) {
        return "";
      }
      let dayNumber = this.currentDate.getDay();
      switch (dayNumber) {
        case 0: {
          weekName = "星期天";
          break;
        }
        case 1: {
          weekName = "星期一";
          break;
        }
        case 2: {
          weekName = "星期二";
          break;
        }
        case 3: {
          weekName = "星期三";
          break;
        }
        case 4: {
          weekName = "星期四";
          break;
        }
        case 5: {
          weekName = "星期五";
          break;
        }
        case 6: {
          weekName = "星期六";
          break;
        }
        default:
          break;
      }
      return `${dsf.date.format(this.currentDate, "m月d日")}${weekName}`;
    },
  },
  watch: {
    dayName() {
      this.updateUrl();
    },
    url() {
      this.updateUrl();
    },
  },
  created() {
    this.reloadDateData();
  },
  methods: {
    search: _.debounce(function () {
      this.updateUrl();
    }, 300),
    reloadDateData() {
      let tempChangeDate = localStorage.getItem("changeDate");
      localStorage.removeItem("changeDate");
      if (tempChangeDate) {
        this.currentDate = new Date(tempChangeDate);
      } else {
        if (this.currentDate == "") {
          this.currentDate = new Date();
        }
      }
      this.updateUrl();
    },
    updateUrl() {
      let url = this.url;
      if (url && url != "") {
        let dayString = dsf.date.format(this.currentDate, "yyyy-mm-dd");
        url += url.indexOf("?") == -1 ? "?" : "&";
        url += `sdate=${dayString} 00:00:00&edate=${dayString} 23:59:59&classTypes=${this.classType}&keyWord=${this.keywords}`;
        this.urlOfflineShift = url;
      } else {
        this.urlOfflineShift = null;
      }
    },
    reduce() {
      let year = this.currentDate.getFullYear();
      let month = this.currentDate.getMonth();
      let day = this.currentDate.getDate();
      day--;
      this.currentDate = new Date(year, month, day);
    },
    add() {
      let year = this.currentDate.getFullYear();
      let month = this.currentDate.getMonth();
      let day = this.currentDate.getDate();
      day++;
      this.currentDate = new Date(year, month, day);
    },
    itemClick(args) {
      this.$emit("itemClick", args);
    },
  },
});
</script>
